<template>
  <div style="text-align: center">
    <el-radio-group v-model="radio" @change="radioChange">
      <el-radio :label="1">1天</el-radio>
      <el-radio :label="2">2天</el-radio>
      <el-radio :label="3">3天</el-radio>
      <el-radio :label="7">7天</el-radio>
      <el-radio :label="15">15天</el-radio>
    </el-radio-group>
    <div style="display: flex; align-items: center;width: 24em;margin: 24px auto;">
      <label style="width: 5.6em">自定义：</label>
      <el-input v-model="day" placeholder="输入禁言天数" @focus="inputChange"/>
      <label style="margin-left: 8px;">天</label>
    </div>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { updateUserBannedChat } from "@/api/url";
import { postFormData } from "@/api/api";

export default {
  name: "BannedChatDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userIdArray: this.value.userIdArray,
      day: '',
      radio: '',
      loading: false,
    }
  },
  methods: {
    radioChange() {
      this.day = ''
    },

    inputChange() {
      this.radio = ''
    },

    cancel() {
      this.$emit("close");
    },

    submit() {
      if ( !this.day && !this.radio ) {
        this.$message({
          message: '请输入或选择禁言天数',
          duration: 2000,
          type: 'warning'
        })
        return  false
      }
      this.loading = true
      let param = {}
      param['idArr'] = this.userIdArray
      param['state'] = 1
      param['day'] = this.day?this.day:this.radio
      postFormData(updateUserBannedChat, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }

  }

}
</script>

<style scoped>

</style>
